import React, { Fragment, useCallback } from "react";
import { useReactToPrint } from "react-to-print";

const HtmlToPdfButton = (props) => {
    
    const getPrintContent = () => {
        return props.divPrintRef.current;
    };

    const handleBeforePrint = useCallback(() => {
        return Promise.resolve();
    }, []);

    const handleAfterPrint = useCallback(() => {
        props.setGeneratingPdf(false);
    }, []);

    const handlePrint = useReactToPrint({
        documentTitle: props.fileName,
        onAfterPrint: handleAfterPrint,
        onBeforePrint: handleBeforePrint
    });

    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    const onClickPrintDocument = async () => {
        props.setGeneratingPdf(true);
        await sleep(2000);

        handlePrint(getPrintContent);
    }
    
    return(
        <Fragment>
            <button type="button" className="btn btn-primary btn-label float-end" title="Download PDF"
                onClick={onClickPrintDocument}
            >
                <i className="ri-download-line label-icon align-bottom" /> Download PDF
            </button>
        </Fragment>
    );
};

export default HtmlToPdfButton;